<template>
  <div class="add_main">
    <el-form ref="goodDetailForm" :model="goodDetailForm" label-width="140px">
      <span class="blue-txt">选择类型</span>
      <el-form-item label="商品类型：">
        <el-cascader
            v-model="goodDetailForm.categoryId"
            :props="{ emitPath: false }"
            :show-all-levels="true"
            :options="productNavTypeTreeList"
            placeholder="请选择类型"
            ref="cascaderCategory"
        ></el-cascader>
      </el-form-item>
      <span class="blue-txt">基础信息</span>
      <el-form-item label="商品名称：">
        <el-input
            v-model="goodDetailForm.name"
            placeholder="请输入商品名称"
            clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="商品型号：">
        <el-input
            @input="getModelCode"
            v-model="goodDetailForm.model"
            placeholder="请输入商品型号"
            clearable
        ></el-input>
        <div style="color: red;" v-if="isSearch">
          * 没有匹配到素材库型号, 将以填写型号为准
        </div>
      </el-form-item>
      <el-form-item label="" class="modelCodeStyle" v-if="isModelListShow">
        <div class="modelStyle" v-loading="modelListLoading"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-text="详情搜索中">
          <div @click="setCurrentIndex(item, index)" :class="{'active' : index == currentIndex}"
               style="cursor: pointer;" v-for="(item, index) in modelList" :key="index">
            型号: {{ item.modelCode }}
            <div style="margin-right: 10px; height:1px; background: #DCDFE6"></div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="商品品牌：">
        <el-autocomplete
            v-model="goodDetailForm.brandName"
            :fetch-suggestions="querySearchAsync"
            placeholder="请选择品牌 可搜索"
            @select="handleSelect"
        ></el-autocomplete>
      </el-form-item>
      <!-- <el-form-item label="商品排序：">
        <el-input
            v-model="goodDetailForm.order"
            placeholder="数值越高越靠后"
            clearable
        ></el-input>
      </el-form-item> -->
      <el-form-item label="服务内容：">
        <el-input
            type="textarea"
            v-model="goodDetailForm.serviceContent"
            placeholder="例如：正品保障、7天无理由退换货、15天换货，多个请使用中文顿号分隔"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品编码：">
        <el-input
            v-model="goodDetailForm.code"
            placeholder="请输入商品编码"
            clearable
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="商品归属：">
        <el-radio-group v-model="goodDetailForm.sourceType">
          <el-radio :label="0">自有商品</el-radio>
          <el-radio :label="1">选择供应商</el-radio>
          <el-select
              filterable
              v-model="goodDetailForm.sourceId"
              placeholder="请选择供应商（可搜索）"
              clearable
              @blur="select_blur_supplier"
            >
            <el-option
              v-for="(item,index) in supplierList"
              :key="index"
              :label="item.proSupplierName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-radio-group>
      </el-form-item> -->

      <el-form-item label="商品归属：">
        <el-radio-group @change="changeType" v-model="radio" style="margin-right:15px;">
          <el-radio :label="1">自有商品</el-radio>
          <el-radio :label="2">供应商商品</el-radio>
        </el-radio-group>
        <el-select
            v-if="!typeShow"
            filterable
            v-model="goodDetailForm.sourceId"
            placeholder="请选择供应商（可搜索）"
            clearable
            @change="select_blur_supplier"
            @clear="clearSupplier"
        >
          <el-option
              v-for="(item,index) in supplierList"
              :key="index"
              :label="item.proSupplierName"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择规格模板：">
        <!-- <el-autocomplete style="width: 300px;" v-model="propertyName" :fetch-suggestions="querySearchAsync1"
                         placeholder="请选择"
                         @select="handleSelect1" clearable @clear="clearBtn"></el-autocomplete> -->
        <el-select v-model="goodDetailForm.propertyGroupId">
          <el-option v-for="(item, index) in propertyList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <!-- <el-button style="margin-left: 20px;" type="primary" @click="goJumpAttributeTem">自定义规格</el-button> -->
      </el-form-item>
      <span class="blue-txt">商品描述</span>
      <el-form-item label="商家图片：" style="margin-bottom: 50px">
        <draggable
            :list="goodDetailForm.pictures"
            :group="{ sort: true, animation: 500 }"
        >
          <div
              class="img_box"
              v-for="(item, index) in goodDetailForm.pictures"
              :key="index"
          >
            <p class="del_box" @click.stop="handleDelPic(index)">
              <img src="../../../assets/del-icon.png" alt/>
            </p>
            <img
                :src="item.url"
                alt
                @click.stop="handleBigPic(item.url)"
            />
            <p class="set_main">
              <el-button size="mini" @click.stop="setMain(index)">{{
                  item.type == 0 ? "主图" : "设为主图"
                }}
              </el-button>
            </p>
          </div>
          <span style="color:#f40000;position: absolute;bottom:0;" v-if="isShowNinePic">最多添加9张</span>
          <el-upload
              v-if="!isShowNinePic"
              class="img-uploader"
              action
              :show-file-list="false"
              :auto-upload="false"
              :on-change="handleBusinessPic"
              multiple
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </draggable>
      </el-form-item>
      <el-form-item label="商品描述：" style="margin-top: 50px">
        <weditor
            @catchData="catchDetailData"
            :isAddEditor="true"
            v-model="goodDetailForm.introduce"
            :content="goodDetailForm.introduce"
            :editorHeight="500"
        ></weditor>
      </el-form-item>
    </el-form>
    <div class="sbmit_info">
      <!--      <el-button type="primary" @click="addOrUpdata" :disabled="disabledSpu">保存并设置SKU</el-button>-->
      <el-button type="primary" @click="addOrUpdata">保存并设置SKU</el-button>
    </div>
    <div class="tab_box" v-if="spuId">
      <span class="blue-txt">SKU信息</span>
      <div>
        <el-form label-width="140px" :inline="true">
          <el-form-item label="选择属性组合：">
            <el-button @click="selectScep" size="small" type="success">添加</el-button>
          </el-form-item>
        </el-form>
        <div id="container" class="el-table" v-if="createSkuList[0]">
          <el-table
              :row-class-name="tableRowClassName"
              :data="createSkuList"
              style="width: 100%">
            <el-table-column type="expand">
              <template slot-scope="scoped">
                <el-table
                    :data="scoped.row.saleableSkuPriceItems"
                    style="width: 100%">
                  <el-table-column
                      prop="resellerName"
                      label="分销商"
                      width="180">
                  </el-table-column>
                  <el-table-column
                      label="市场价"
                      width="180">
                    <template slot-scope="props">
                      <el-input class="cost-price" type="number" placeholder="市场价" v-model="props.row.marketPrice"
                                style="width:100%;"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                      label="商家价">
                    <template slot-scope="props">
                      <el-input class="cost-price" type="number" placeholder="商家价" v-model="props.row.merchantsPrice"
                                style="width:100%;"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                      label="零售价">
                    <template slot-scope="props">
                      <el-input class="cost-price" type="number" placeholder="零售价" v-model="props.row.retailPrice"
                                style="width:100%;"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                      label="供货价">
                    <template slot-scope="props">
                      <el-input class="cost-price" type="number" placeholder="供货价" v-model="props.row.supplyPrice"
                                style="width:100%;"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                      label="上下架">
                    <template slot-scope="props">
                      <el-switch
                          v-model="props.row.isShelves"
                          active-color="#13ce66"
                          inactive-color="#ccc">
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column
                      label="远程审核状态">
                    <template slot-scope="props">
                      <el-tag v-if="props.row.remoteShelvesAuditStatus == 2" type="success">审核通过</el-tag>
                      <el-tag v-if="props.row.remoteShelvesAuditStatus == 0" type="info">待提交</el-tag>
                      <el-tag v-if="props.row.remoteShelvesAuditStatus == 1" type="danger">待审核</el-tag>
                      <el-tag v-if="props.row.remoteShelvesAuditStatus == 3" type="warning">审核不通过</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="desc"
                      label="备注">
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column
                label="属性名称">
              <template slot-scope="scoped">
                <el-input v-for="(spec,index) in scoped.row.propertyJsonArr.PropertyList" :key="index" v-model="spec.PropertyValueString" @change="(value) => changeInputSpec(spec, value)"></el-input>
                <span style="font-size: 12px">{{ scoped.row.productSpec }}</span>
                <el-switch
                    v-if="scoped.row.id"
                    v-model="scoped.row.isActive"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    style="margin-left: 10px"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column
                label="商品编码"
                :render-header="button">
              <template slot-scope="scoped">
                <el-input type="text" v-model="scoped.row.productCode"></el-input>
              </template>
            </el-table-column>
            <el-table-column
                :render-header="button1"
                label="成本价格">
              <template slot-scope="scoped">
                <el-input class="cost-price" type="number" placeholder="价格必须大于零" v-model="scoped.row.costPrice"
                          @input="(value) => watchCostPrice(value, scoped.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column
                :render-header="button2"
                label="属性图">
              <template slot-scope="scoped">
                <div class="cell up_img">
                  <div class="el_upload_sku">
                    <input
                        class="el_upload_input"
                        @change="handleSkuChange($event, scoped.row.index)"
                        id="el_upload_input"
                        type="file"
                    />
                    <img
                        v-if="scoped.row.pictureUrl"
                        :src="scoped.row.pictureUrl"
                        class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <span
                        class="mask"
                        v-if="scoped.row.pictureUrl"
                        @click.stop="delSkuPic(scoped.row.index)"
                    >
                        <i class="el-icon-delete"></i>
                      </span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                label="操作">
              <template slot-scope="scoped">
                <el-button size="mini" type="danger" @click="deleteSku(scoped.row, scoped.row.index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="sbmit_info" v-if="createSkuList[0]">
      <el-button type="primary" v-preventClick @click="handleSubmitSku">保存SKU</el-button>
    </div>
    <!-- 图片放大 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" height="100%" :src="dialogImageUrl" alt/>
    </el-dialog>
    <!-- 选择属性组合 -->
    <el-dialog title="选择属性组合" width="35%" :visible.sync="dialogCombination" :append-to-body="true">
      <!-- <el-form inline>
        <el-form-item>
          <el-input v-model="" placeholder="输入属性值"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" >筛选</el-button>
          <el-button size="mini" type="danger" >重置</el-button>
        </el-form-item>
      </el-form> -->
      <el-table ref="diaTable" border max-height="500px" :data="skuPreViewList" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="规格名称" prop="productSpec" align="left"></el-table-column>
      </el-table>
      <div slot="footer">
        <el-button type="primary" @click="confrimSku">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="自由组合" :visible.sync="dialogMaintain" v-if="dialogMaintain">
      <maintain :groupId="goodDetailForm.propertyGroupId" :checkList="checkList"
                @getPropertyValue="getPropertyValue"></maintain>
    </el-dialog>
  </div>
</template>

<script>
import {
  ProductCreate, //上传商品
  getQiniuToken,
  CategoryGetTree, //获取商品类型
  brandGetAll, //品牌列表
  PropertyGroupGetAll,
  GetProductSkuPreView,
  GetProducDetail,
  BatchCreateAndUpdate,
  ProductSkuGetAll,
  ProductSkuDelete,
  ProductUpdate, //商品编辑
  GetAllProperties,
  GetAllSupplier,
  GetKSAXCommodityLibrary, GetSimpleList, ksaxBaseUrl, Product_SpuModelGetDetail
} from "../../../api/api";
import draggable from "vuedraggable";
import weditor from "../../../components/WangEditor";
import {getButtonList} from "../../../promissionRouter";
import maintain from "./components/maintain.vue"
import _ from 'lodash'
import axios from "axios";

export default {
  components: {
    weditor,
    draggable,
    maintain,
  },
  watch: {
    "goodDetailForm.categoryId": {
      handler(n, o) {
        // if (this.$refs['cascaderCategory'].getCheckedNodes()[0].pathNodes){
        if (this.$refs['cascaderCategory'].getCheckedNodes()[0]) {
          let arr = this.$refs['cascaderCategory'].getCheckedNodes()[0].pathNodes;
          this.goodDetailForm.categories = [];
          arr.forEach(x => {
            this.goodDetailForm.categories.push({
              categoryId: x.value,
              categoryName: x.label
            });
          })
          // console.log('this.goodDetailForm.categories------', this.goodDetailForm.categories)
        }
      },
      deep: true
    },
    "goodDetailForm.propertyGroupId": {
      handler(n, o) {
        this.getAllProperties(n)
      },
      deep: true
    },
    "goodDetailForm.pictures": {
      handler(n, o) {
        if (n.length) {
          this.skuMainpic = n[n.findIndex(val => val.type == 0)].url
        }
        if (n.length >= 9) {
          this.isShowNinePic = true
        } else {
          this.isShowNinePic = false
        }
      },
      deep: true
    }
  },
  data() {
    return {
      isSearch: false,
      afterFlatTypeTree: [],  // tree 转 一维数组数据
      originTypeTree: null,
      checkedModelId: null,
      currentIndex: null,
      isModelListShow: false,
      modelListLoading: false,
      modelList: [],
      propertyName: '',
      // disabledSpu: false,
      disabledSku: false,
      isShowNinePic: false, // 最多显示图片
      dialogMaintain: false,
      dialogCombination: false, // 属性组合展示
      spuId: null,
      qiniuToken: "",
      brandList: [], // 品牌列表
      radio: 1,
      typeShow: true,
      goodDetailForm: {
        categoryId: null,
        name: null, //商品名称
        model: null, //型号
        brandId: null, //商品品牌
        brandName: '',
        // order: null,
        serviceContent: '',
        code: '',
        introduce: '',
        isActive: true,
        pictures: [],
        propertyGroupId: null,
        propertyGroupName: '',
        properties: [],
        sourceType: 0,
        sourceId: 0
      },
      propertyList: [], // 属性模板
      skuPreViewList: [], // 规格组合
      checkedSkuList: [],
      productNavTypeTreeList: [], //商品类型
      createSkuList: [], //规格最终生成的数组
      dialogVisible: false,
      dialogImageUrl: "",
      checkList: [],
      supplierList: [],
      skuMainpic: null,
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log(to, from, '路由')
  //   if (from.path == "/Product/AttributeTemplate/Maintain") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
  created() {
    if (this.$route.query.copyid) {
      this.getAxSpuDetail()
    }
    this.getQiniuToken();
    this.getProductNavTypeTree();
    this.getBrandList();
    this.getSupplierList();
    this.getPropertyList()
  },
  methods: {
    getIdByLevelTwo(currentItem) {
      let ids = [];
      let secondId;
      let thirdId;
      secondId = currentItem.id;
      ids.push(secondId)

      let firstItem = this.afterFlatTypeTree.filter((item) => {
        return item.id = currentItem.pid
      })
      ids.unshift(firstItem.id)
      let thirdPid = secondId;
      let thirdItem = this.afterFlatTypeTree.filter((item) => {
        return item.pid = thirdPid
      })
      thirdId = thirdItem.id;
      ids.push(thirdId)
      return ids
    },
    getIdByLevelOne(currentItem) {
      let ids = [];
      let firstId;
      let secondId;
      let thirdId;
      firstId = currentItem.id;
      ids.push(firstId)
      let secondPid = firstId;
      let secondItem = this.afterFlatTypeTree.filter((item) => {
        return item.pid = secondPid
      })
      secondId = secondItem.id;
      ids.push(secondId)
      let thirdPid = secondId;
      let thirdItem = this.afterFlatTypeTree.filter((item) => {
        return item.pid = thirdPid
      })
      thirdId = thirdItem.id;
      ids.push(thirdId)
      return ids
    },
    getIdByLevelThree(currentItem) {
      let ids = [];
      let secondId;
      let thirdId;
      thirdId = currentItem.id;
      let secondItem = this.afterFlatTypeTree.filter((item) => {
        return item.id = currentItem.pid
      })
      ids.unshift(secondItem.id)
      let thirdItem = this.afterFlatTypeTree.filter((item) => {
        return item.id = secondItem.pid
      })
      ids.unshift(thirdItem.id)
      ids.push(thirdId)
    },
    button2() {
      return (
          <div>
            <span style="margin-right:5px;">属性图</span>
            <el-button on-click={() => this.copyPictureUrl()} type="primary" size="small">向下覆盖</el-button>
          </div>
      )
    },
    button1() {
      return (
          <div>
            <span style="margin-right:5px;">成本价</span>
            <el-button on-click={() => this.copyCostPrice()} type="primary" size="small">向下覆盖</el-button>
          </div>
      )
    },
    button() {
      return (
          <div>
            <span style="margin-right:5px;">商品编码</span>
            <el-button on-click={() => this.copyProductCode()} type="primary" size="small">向下覆盖</el-button>
          </div>
      )
    },
    tableRowClassName({row, rowIndex}) {
      row.index = rowIndex;
    },
    getIds(typeName) {
      // console.log('productNavTypeTreeListproductNavTypeTreeList', this.productNavTypeTreeList)
      // console.log('afterFlatTypeTreeafterFlatTypeTreeafterFlatTypeTreeafterFlatTypeTree', this.afterFlatTypeTree)
      let ids = [];
      let firstId = null;
      let typeArr = typeName.split(',')
      // typeName 名称顺序与级别顺序一致
      let firstName = typeArr[0];
      // console.log('firstName: ' + firstName)

      let FlatTypeTree = [...this.afterFlatTypeTree]
      let currentItem = [];
      FlatTypeTree.forEach((item) => {
        if (item.name === firstName) {
          currentItem.push(item)
        }
      })
      // console.log('FlatTypeTree', FlatTypeTree)
      // console.log('currentItem', currentItem, currentItem.level)
      // let currentItem = this.afterFlatTypeTree.filter((item) => {
      //   return item.name = firstName
      // })

      if (currentItem.level == 1) {
        return firstId = this.getIdByLevelOne(currentItem)
      }

      if (currentItem.level == 2) {
        // console.log('222222222222222')
        // return firstId = this.getIdByLevelTwo(currentItem)
      }

      if (currentItem.level == 3) {
        return firstId = this.getIdByLevelThree(currentItem)
      }

    },
    flatTypeTree(arr) {
      let newArr = [];
      for (let i = 0; i < arr.length; i++) {
        newArr.push({id: arr[i].value, name: arr[i].label, pid: arr[i].ParentId, level: arr[i].level});
        if (arr[i].children && arr[i].children.length > 0) {
          newArr = newArr.concat(this.flatTypeTree(arr[i].children))
        }
      }
      return newArr;
    },
    async setCurrentIndex(item, index) {
      console.log('item index', item, index)
      this.currentIndex = index;
      this.checkedModelId = item.id; // 查询商品的型号Id
      if (this.checkedModelId) {
        let params = {}
        params.Id = this.checkedModelId
        let res = await Product_SpuModelGetDetail(params)
        console.log('型号查询结果', res);
        if (res.data.success) {
          this.goodDetailForm.pictures = []
          let object = res.data.result.data;
          if (object.brandName) {
            // 根据商城 品牌名称 查询 erp 对应的 品牌名称  品牌Id
            let brandItem = this.brandList.filter(Item => Item.value === object.brandName)
            console.log('brandItem', brandItem)
            if (brandItem && brandItem.length > 0) {
              this.goodDetailForm.brandName = brandItem[0].value;
              this.goodDetailForm.brandId = brandItem[0].id;
            }
          }
          // let categoryName = object.typeNames;
          // if (!categoryName) {
          //   return this.$message.error('缺少级别名称')
          // }
          // // // 根据类型名称获取  三级类型id
          // let categoryIds = this.getIds(categoryName);
          // console.log('categoryIdscategoryIdscategoryIds', categoryIds)
          // let currentTypeId = this.getCurrentTypeId(categoryName)

          // console.log('categoryIdscategoryIdscategoryIds', this.categoryIds)
          // this.goodDetailForm.categoryId = [];
          if (object.modelCode) {
            this.goodDetailForm.model = object.modelCode;
          }
          if (object.proContent) {
            this.goodDetailForm.introduce = object.proContent
          }
          if (object.businessPics && object.businessPics.length > 0) {
            object.businessPics.forEach((item, index) => {
              this.goodDetailForm.pictures.push({
                url: item,
                type: index == 0 ? 0 : 1
              })
            })
          }
          this.isModelListShow = false;
          this.modelListLoading = false;
          this.modelList = [];
        } else {
          this.isModelListShow = false;
          this.modelListLoading = false;
          this.modelList = [];
          this.$message.error(res.data.error.message)
        }
      }
    },
    getModelCode: _.debounce(async function (val) {
      try {
        if (val) {
          this.currentIndex = null // 选中索引
          this.modelList = []  // 重置型号搜索结果
          this.isModelListShow = true  // 显示搜索结果框
          this.modelListLoading = true  // 搜索结果框loading
          // console.log('process.env.NODE_ENV', process.env.NODE_ENV)
          // console.log('getModelCode', val)
          let params = {}
          params.modelCode = val
          let res = await GetSimpleList(params);
          if (res.data.success) {
            if (res.data.result.data && res.data.result.data.length > 0) {
              this.modelList = res.data.result.data
              this.modelListLoading = false
              this.isSearch = false // 隐藏搜索
            } else {
              this.isModelListShow = false
              this.modelListLoading = false
              this.isSearch = true
              // return this.$message.error('暂无匹配型号')
              // console.log('暂无匹配型号')
            }
          } else {
            this.$message.error(res.data.error.message)
            this.modelList = []
            this.isModelListShow = false
            this.modelListLoading = false
          }
          // console.log('modelList', res);
        } else {
          this.modelList = []
          this.isModelListShow = false
          this.modelListLoading = false
          this.currentIndex = null
          // 清空之前已经查询的商品详情数据
          this.goodDetailForm.pictures = [];
          this.goodDetailForm.brandName = '';
          this.goodDetailForm.brandId = null;
          this.goodDetailForm.model = null;
          this.goodDetailForm.categoryId = null;
          this.isSearch = false; // 隐藏  搜索 为空 提示
        }

      }catch (e) {
        this.modelList = []
        this.isModelListShow = false
        this.modelListLoading = false
        this.currentIndex = null
        console.log(e)
      }
    }, 2000),
    handleSelect1(val) {
      this.goodDetailForm.propertyGroupId = val.id
    },
    clearBtn(val) {
      this.goodDetailForm.propertyGroupId = null
    },

    async querySearchAsync1(queryString, cb) {
      if (queryString) {
        let res = await this.getPropertyList(queryString);
        cb(res);
      } else {
        let res = await this.getPropertyList();
        cb(res);
      }
    },
    getPropertyList() {
      let obj = {
        IsActive: true,
        SkipCount: 0,
        MaxResultCount: 100,
      };
      PropertyGroupGetAll(obj).then((res) => {
        // console.log('this.propertyList', this.propertyList)
        this.propertyList = res.data.result.items || []
        if (this.propertyList.length) {
          this.goodDetailForm.propertyGroupId = this.propertyList[0].id
        }
      })
    },

    // getPropertyList(key) {
    //   let obj = {
    //     IsActive: true,
    //     SkipCount: 0,
    //     MaxResultCount: 100,
    //   };
    //   if (key) {
    //     obj.Name = key;
    //   }
    //   return new Promise((resolve, reject) => {
    //     PropertyGroupGetAll(obj).then((res) => {
    //       if (res.data.success) {
    //         this.propertyList = res.data.result.items.map((item) => {
    //           return {
    //             value: item.name,
    //             id: item.id,
    //           };
    //         });
    //         // this.propertyList = res.data.result.items || []
    //         resolve(this.propertyList);
    //       } else {
    //         this.$message.error(res.data.msg);
    //         reject(res.data.msg);
    //       }
    //     });
    //   });
    // },
    // remoteMethod_supplier(query) {
    //   debugger
    //   let that = this;
    //   let params = {
    //     SkipCount: 0,
    //     MaxResultCount: 200
    //   };
    //   if (query !== '') {
    //     params.name = query;
    //   }
    //   GetAllSupplier(params).then((res) => {
    //     debugger
    //     if (res.data.success) {
    //       that.supplierList = res.data.result.items;
    //     }
    //   });
    // },

    // 营客通商品库详情
    getAxSpuDetail() {
      let data = {
        spuId: this.$route.query.copyid,
        pageIndex: 1,
        pageSize: 10
      }
      GetKSAXCommodityLibrary(data).then(res => {
        if (res.data.success) {
          let object = res.data.result.data.data[0] || {}
          object.businessPics.forEach(item => {
            this.goodDetailForm.pictures.push({
              url: item.spuPicUrl,
              type: item.isMain ? 0 : 1
            })
          })
          this.goodDetailForm.name = object.proName
          this.goodDetailForm.introduce = object.proContent
          this.goodDetailForm.model = object.modelCode
        }
      })
    },
    select_blur_supplier() {
      // this.sourceType = 1;
      this.getSupplierList();
    },
    clearSupplier() {
      // console.log('clear')
      this.goodDetailForm.sourceType = 0
      this.goodDetailForm.sourceId = 0
    },
    changeType(val) {

      if (val === 1) {
        this.typeShow = true;
        this.goodDetailForm.sourceType = 0
        this.goodDetailForm.sourceId = 0
      } else {
        this.typeShow = false;
        this.goodDetailForm.sourceType = 1
        this.goodDetailForm.sourceId = null
      }
    },
    getSupplierList() {
      let params = {
        SkipCount: 0,
        MaxResultCount: 200
      };
      let that = this;
      GetAllSupplier(params).then((res) => {
        if (res.data.success) {
          that.supplierList = res.data.result.items;
        }
      });
    },
    watchCostPrice(val, data) {
      if (val <= 0) {
        data.costPrice = null
      }
    },
    getAllProperties() {
      GetAllProperties({PropertyGroupId: this.goodDetailForm.propertyGroupId, showAll: true}).then(res => {
        if (res.data.success) {
          let arr = res.data.result.items || []
          let list = []
          arr.forEach(item => {
            item.propertyValues.forEach(val => {
              list.push({
                propertyId: item.propertyId,
                propertyString: item.propertyName,
                propertyValueId: val.propertyValueId,
                propertyValueString: val.propertyValueString
              })
            })
          })
          this.checkList = this.listToTree(list)
          this.goodDetailForm.properties = list
        }
      })
    },
    goJumpAttributeTem() {
      if (!this.goodDetailForm.propertyGroupId) {
        return this.$message.warning('请选择属性模板！')
      }
      this.dialogMaintain = true
    },
    getBrandList(key) {
      let obj = {
        IsActive: true,
        SkipCount: 0,
        MaxResultCount: 100000,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    handleSelect(item) {
      this.goodDetailForm.brandId = item.id;
    },
    listToTree(arr) {
      let list = []
      // arr.forEach(item => {
      //   list.push({
      //     id: item.propertyId,
      //     checkedCities: item.propertyValues.map(val => {
      //       return val.propertyValueId
      //     })
      //   })
      // })
      arr.forEach(item => {
        let id = item.propertyId
        let index = list.findIndex(val => val.id == item.propertyId)
        if (index > -1) {
          list[index].checkedCities.push(item.propertyValueId)
        } else {
          list.push({
            id: item.propertyId,
            checkedCities: [item.propertyValueId]
          })
        }
        // if (obj.hasOwnProperty(item.checkedCities)) {
        //   list[obj[item.id]][item.checkedCities] = item.propertyId
        //   list[obj[item.propertyId]][item.checkedCities] = item.propertyValueId
        // } else {
        //   obj[item.propertyId] = index++
        //   list.push({
        //     id: item.propertyId,
        //     checkedCities: [item.propertyValueId]
        //   })
        // }
      })
      // console.log(arr, list)
      return list
    },
    catchDetailData(data) {
      this.goodDetailForm.introduce = data;
    },
    // 商品类型
    getProductNavTypeTree() {
      let that = this;
      CategoryGetTree({parentId: 0, isActive: true}).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
        let FlatTypeTree = this.flatTypeTree(that.productNavTypeTreeList);
        this.afterFlatTypeTree = FlatTypeTree
        // console.log('this.afterFlatTypeTree=====', this.afterFlatTypeTree)
        // console.log(that.productNavTypeTreeList, 'kkkkk')
      });
    },
    loopTypeTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        item.ParentId = item.data.ParentId;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    loopMenuTree(treeList, level = 0) {
      level++
      const newList = treeList.filter(item => {
        item.level = level;
        item.value = item.data.Id;
        item.label = item.data.Name;
        item.ParentId = item.data.ParentId;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children, level)
        }
        return true;
      })
      return newList;
    },
    //获取七牛token
    getQiniuToken() {
      var that = this;
      getQiniuToken().then((res) => {
        that.qiniuToken = res.data;
      })
          .catch(() => {
          });
    },
    handleDelPic(index) {
      let that = this;
      that.goodDetailForm.pictures.splice(index, 1);
    },
    handleBusinessPic(file) {
      let that = this;
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils
          .uploadImgToQiniu(file.raw, qiniuData)
          .then((res) => {
            let itemPic;
            if (that.goodDetailForm.pictures[0]) {
              itemPic = {
                url: res,
                type: 1,
              };
            } else {
              itemPic = {
                url: res,
                type: 0,
              };
            }
            that.goodDetailForm.pictures.push(itemPic);
          })
          .catch((err) => {
            that.$message.error(err);
          });
    },
    // 属性组合
    selectScep() {
      GetProductSkuPreView({ProductId: this.spuId}).then(res => {
        if (res.data.success) {
          this.dialogCombination = true
          this.skuPreViewList = res.data.result || []
          this.$nextTick(() => {
            this.createSkuList.forEach(row => {
              let index = this.skuPreViewList.findIndex(i => {
                return i.speCode === row.speCode
              })
              if (index > -1) {
                // this.$set(this.skuPreViewList[i].items[findTargIndex], 'isCheck', true)
                this.$refs.diaTable.toggleRowSelection(this.skuPreViewList[index])
              }
            })
          })
        }
      })
    },
    deepCopy(obj) {
      let newObj = null;
      if (typeof (obj) == 'object' && typeof (obj) !== null) {
        newObj = obj instanceof Array ? [] : {};
        for (var i in obj) {
          newObj[i] = this.deepCopy(obj[i]);
        }
      } else {
        newObj = obj;
      }
      return newObj;
    },
    getPropertyValue(arr) {
      // console.log(arr, 'dddd')
      this.dialogMaintain = false
      this.goodDetailForm.properties = arr
      this.checkList = this.listToTree(arr)
    },
    // 添加/编辑商品
    addOrUpdata() {
      // if (this.disabledSpu) { // 此状态下不能再次提交
      //   return false
      // }

      let that = this;
      if (that.goodDetailForm.sourceId) {
        // params.sourceId = 0;
        that.goodDetailForm.sourceType = 1;
      }
      if (!that.goodDetailForm.categoryId)
        return that.$message.error("请选择商品类型！");
      if (!that.goodDetailForm.name)
        return that.$message.error("请输入商品名称！");
      if (!that.goodDetailForm.model)
        return that.$message.error("请输入商品型号！");
      if (!that.goodDetailForm.brandId)
        return that.$message.error("请选择商品品牌！");
      if (that.goodDetailForm.sourceType === null)
        return that.$message.error("请选择商品归属！");
      if (!this.goodDetailForm.code)
        return that.$message.error("请填写商品编码！");
      // if (that.goodDetailForm.sourceType === 1 && that.goodDetailForm.sourceId === null)
      //   return that.$message.error("请选择供应商");
      if (!that.goodDetailForm.propertyGroupId)
        return that.$message.error("请选择属性模板！");
      if (!that.goodDetailForm.pictures[0])
        return that.$message.error("请上传商品商家端展示图册！");
      if (!that.goodDetailForm.introduce)
        return that.$message.error("请填写商品描述！");
      // console.log(that.goodDetailForm, '商品信息')
      let params = JSON.parse(JSON.stringify(that.goodDetailForm));

      that.$confirm("确认提交吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      })
          .then(() => {
            // if (!that.$route.query.id) {
            ProductCreate(params).then((res) => {
              if (res.data.success) {
                that.$message.success('添加成功！');
                // that.disabledSpu = true
                that.spuId = res.data.result.id
                this.createSkuList = []
                // this.$router.go(0);
              } else {
                // that.$message.error(res.data.msg);
              }
            });
            // } else {
            //   ProductUpdate(that.goodDetailForm).then((res) => {
            //     if (res.data.success) {
            //       that.$message.success('编辑成功！');
            //       // this.getProductSpuDetail();
            //       // this.$router.go(0);
            //     } else {
            //       // that.$message.error(res.data.msg);
            //     }
            //   });
            // }
          });
    },
    handleSelectionChange(arr) {
      console.log(arr,'规格')
      this.checkedSkuList = arr
    },
    confrimSku() {
      let list = []
      this.checkedSkuList.forEach(item => {
        list.push({
          "speCode": item.speCode,
          "productSpec": item.productSpec,
          "propertyJson": item.propertyJson,
          "propertyJsonArr": JSON.parse(item.propertyJson),
          "productCode": "",
          "pictureUrl": this.skuMainpic,
          "costPrice": null,
          "isActive": true
        })
      })
      if (!this.createSkuList[0]) {
        this.createSkuList = list
      } else {
        list.forEach(item => {
          item.propertyJsonArr.PropertyList.forEach(val => {
            this.createSkuList.forEach(item2 => {
              item2.propertyJsonArr.PropertyList.forEach(val2 => {
                if (val2.PropertyValueId == val.PropertyValueId) {
                  val.PropertyValueString = val2.PropertyValueString
                }
              })
            })
          })
        })
        this.createSkuList = this.arrayDup(this.createSkuList, list)
      }
      console.log(this.createSkuList, 'this.createSkuList')
      this.dialogCombination = false
    },
    // 处理同一属性名称
    changeInputSpec(spec,value) {
      this.createSkuList.forEach(item => {
        item.propertyJsonArr.PropertyList.forEach(val => {
          if (spec.PropertyValueId == val.PropertyValueId) {
            val.PropertyValueString = value
          }
        })
      })
    },
    // 去重
    arrayDup(arr1, arr2) {
      let list1 = [], list2 = []
      for (let i = 0; i < arr1.length; i++) {
        for (let j = 0; j < arr2.length; j++) {
          if (arr1[i].speCode == arr2[j].speCode) {
            list1.push(arr1[i])
          }
        }
      }
      arr2.forEach(item => {
        let index = arr1.findIndex(i => {
          return i.speCode === item.speCode
        })
        if (index < 0) {
          list2.push(item)
        }
      })
      return list1.concat(list2)
    },
    // 保存sku
    handleSubmitSku() {
      // 校验成本价不能为空
      let elements = document.querySelectorAll('#container .cost-price input');
      for (let el of elements) {
        el.classList.remove("input-err");
      }
      for (let el of elements) {
        if (isNaN(el.valueAsNumber)) {
          el.classList.add("input-err");
          return this.$message.error('成本价不能为空');
        }
      }

      // console.log(this.createSkuList,'保存sku')
      // let list = this.createSkuList
      this.createSkuList.forEach(i => {
        i.productSpecExt = ''
        i.propertyJsonArr.PropertyList.forEach(v => {
          i.productSpecExt += `${v.PropertyString}*`
        })
        i.propertyJsonExt = JSON.stringify(i.propertyJsonArr)
      })
      let data = {
        productId: this.spuId,
        items: this.createSkuList
      }
      BatchCreateAndUpdate(data).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功！')
          // this.disabledSku = true
          // this.disabledSpu = false
        }
      })
    },
    // getSkuList() {
    //   ProductSkuGetAll({ProductId: this.spuId}).then(res => {
    //     this.createSkuList = res.data.result.items || []
    //   })
    // },
    deleteSku(data, index) {
      // if (data.id) {
      //   ProductSkuDelete({ids: [data.id]}).then(res => {
      //     if (res.data.success) {
      //       this.getSkuList()
      //     }
      //   })
      // } else {
      this.createSkuList.splice(index, 1)
      // }
    },
    // 图片放大
    handleBigPic(src) {
      this.dialogVisible = true;
      this.dialogImageUrl = src;
    },
    setMain(index) {
      let that = this;
      that.goodDetailForm.pictures.forEach((v, i) => {
        if (index == i) {
          var arr = [
            {
              url: that.goodDetailForm.pictures.splice(i, 1)[0].url,
              type: 0,
            },
          ];
          that.goodDetailForm.pictures = [
            ...arr,
            ...that.goodDetailForm.pictures,
          ];
        }
      });
      that.goodDetailForm.pictures.forEach((v, i) => {
        if (i > 0) {
          v.type = 1;
        }
      });
    },
    handleSkuChange(e, i) {
      let that = this;
      let file = e.target.files[0];
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils.uploadImgToQiniu(file, qiniuData).then((res) => {
        window.document.getElementById("el_upload_input").value = null;
        if (i != null) {
          that.createSkuList[i].pictureUrl = res;
        }
      })
          .catch((err) => {
            that.$message.error(err);
          });
    },
    delSkuPic(i) {
      this.createSkuList[i].pictureUrl = "";
    },
    copyProductCode() {
      let productCode = ''
      if (this.createSkuList[0].productCode) {
        productCode = this.createSkuList[0].productCode
        this.createSkuList.forEach(item => {
          item.productCode = productCode
        })
      } else {
        this.$message.warning('请先填写第一行内容！')
      }
    },
    copyCostPrice() {
      let costPrice = ''
      if (this.createSkuList[0].costPrice) {
        costPrice = this.createSkuList[0].costPrice
        this.createSkuList.forEach(item => {
          item.costPrice = costPrice
        })
      } else {
        this.$message.warning('请先填写第一行内容！')
      }
    },
    copyPictureUrl() {
      let pictureUrl = ''
      if (this.createSkuList[0].pictureUrl) {
        pictureUrl = this.createSkuList[0].pictureUrl
        this.createSkuList.forEach(item => {
          item.pictureUrl = pictureUrl
        })
      } else {
        this.$message.warning('请先填写第一行内容！')
      }
    },
  },
};
</script>
<style scoped>
.active {
  color: #2a7ffa;
  background-color: pink;
}

.modelStyle {
  border: 1px solid red;
  width: 300px;
  min-height: 200px;
  max-height: 300px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  overflow-y: scroll;
  padding-top: 10px;
  padding-left: 10px;
  line-height: 35px;
}

.modelCodeStyle ::-webkit-scrollbar {
  width: 4px;
}

.modelCodeStyle ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.modelCodeStyle ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.add_main {
  min-height: 100%;
  padding: 10px 20px 100px 20px;
  overflow: hidden;
}

.blue-txt {
  color: #409eff;
}

.el-input,
.el-select,
.el-cascader,
.el-autocomplete {
  width: 300px;
}

.el-textarea {
  width: 500px;
}

.el-form {
  padding-left: 20px;
}

.tab_box {
  padding: 20px;
}

.img_box {
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  float: left;
  position: relative;
  margin-right: 10px;
}

.img_box img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.bg_box {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0;
}

.bg_box:hover {
  opacity: 1;
}

.del_box {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
}

.del_box img {
  height: 100%;
  width: 100%;
}

.img-uploader {
  display: inline-block;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
}

.img-uploader:hover {
  border-color: #409eff;
}

.img-uploader .el_upload {
  height: 80px;
  width: 80px;
}

.el-upload img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.avatar-uploader-icon {
  font-size: 24px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.set_main {
  position: absolute;
  bottom: -40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.set-share {
  position: absolute;
  bottom: -70px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.params_box div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}

.from_tit {
  color: #606266;
  margin-right: 20px;
}

.params_box ul {
  list-style: none;
  margin: 0;
  padding: 0 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.params_box ul > li {
  padding: 0 10px;
  color: #fff;
  border-radius: 15px;
  font-size: 14px;
  margin-right: 20px;
}

.el_upload_input {
  height: 100px;
  width: 100px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 99;
}

.single_up_img {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.el_upload_sku {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el_upload_sku:hover {
  border-color: #409eff;
}

.el_upload_sku:hover .mask {
  opacity: 1;
}

.mask {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  line-height: 178px;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-table {
  border: 1px solid #999;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  flex: 1;
  width: 100%;
  max-width: 100%;
  font-size: 14px;
  color: #606266;
  background-color: #fff;
}

.el-table table {
  width: 100% !important;
  max-width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

.el-table thead {
  color: #909399;
  table-layout: fixed;
  border-collapse: separate;
  font-weight: 500;
}

.el-table th,
.el-table tr {
  background: #fff;
}

.el-table .el-table__body td,
.el-table .el-table__header tr th {
  padding: 0;
  background: #f6f7f9;
  border-right: 1px solid #dde5e8;
  border-bottom: 1px solid #dde5e8;
  text-align: center;
  overflow: hidden;
  user-select: none;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
}

.el-table .el-table__header th:first-child div.cell {
  border-left: 0;
  background: #f6f7f9;
  padding: 7px 8px;
  font-weight: 100;
  font-size: 12px;
  box-sizing: border-box;
  position: relative;
  vertical-align: middle;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
}

.el-table__body,
.el-table__footer,
.el-table__header {
  table-layout: fixed;
  border-collapse: separate;
}

.el-table th,
.el-table tr {
  background-color: #fff;
  box-sizing: border-box;
  text-align: center;
  width: 100px;
  border-right: 1px solid #dfe6ec;
}

.el-table .el-table__body td div.cell {
  font-size: 12px;
  padding: 9px 8px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
}

.cell .el-input {
  width: 100%;
}

.avatar-box {
  height: 100px;
  width: 100px;
}

.up_img {
  display: flex;
  justify-content: center;
  align-items: center;
}

.sbmit_info {
  padding: 20px;
  display: flex;
  justify-content: center;
  width: 100%;
}

#container /deep/ .cost-price input.input-err {
  border: #F56C6C solid 1px;
}

</style>
